import type { ApiResponse, AuditLog, AuditLogsResponse, UserAuditLogsResponse } from '../../types/api';

import { baseApi } from './baseApi';


interface AuditLogsQueryParams {
  page?: number;
  limit?: number;
  actorId?: number | string;
  action?: string;
  target?: string;
  result?: 'success' | 'failed';
  startDate?: string;
  endDate?: string;
  sortBy?: 'createdAt' | 'action' | 'target' | 'result';
  sortOrder?: 'asc' | 'desc';
}

export const auditLogsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAuditLogs: builder.query<ApiResponse<AuditLogsResponse>, AuditLogsQueryParams>({
      query: (params) => ({
        url: '/audit-logs',
        method: 'GET',
        params,
      }),
      providesTags: ['AuditLog'],
    }),
    getUserAuditLogs: builder.query<
      ApiResponse<UserAuditLogsResponse>,
      { actorId: number | string; params?: Omit<AuditLogsQueryParams, 'actorId'> }
    >({
      query: ({ actorId, params }) => ({
        url: `/audit-logs/${actorId}`,
        method: 'GET',
        params,
      }),
      providesTags: (_result, _error, { actorId }) => [{ type: 'AuditLog', id: `user-${actorId}` }],
    }),
    getAuditLogById: builder.query<ApiResponse<{ log: AuditLog }>, string>({
      query: (id) => ({
        url: `/audit-logs/log/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'AuditLog', id }],
    }),
  }),
});

export const {
  useGetAuditLogsQuery,
  useGetUserAuditLogsQuery,
  useGetAuditLogByIdQuery,
} = auditLogsApi;

